/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CloseReportResource { 
    status: CloseReportResource.StatusEnum;
    conclusion?: string;
    companyNo?: string;
    points?: number;
    transactionStatus?: CloseReportResource.TransactionStatusEnum;
    invoiceNo?: string;
    invoiceDate?: string;
    invoiceTime?: string;
    errorMessage?: string;
}
export namespace CloseReportResource {
    export type StatusEnum = 'INITIALIZED' | 'PROCESSING' | 'ON_HOLD' | 'CLOSED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Processing: 'PROCESSING' as StatusEnum,
        OnHold: 'ON_HOLD' as StatusEnum,
        Closed: 'CLOSED' as StatusEnum
    };
    export type TransactionStatusEnum = 'INITIALIZED' | 'SUCCESS' | 'VALIDATION_PENDING' | 'ERROR' | 'DECLINED' | 'REPORTED';
    export const TransactionStatusEnum = {
        Initialized: 'INITIALIZED' as TransactionStatusEnum,
        Success: 'SUCCESS' as TransactionStatusEnum,
        ValidationPending: 'VALIDATION_PENDING' as TransactionStatusEnum,
        Error: 'ERROR' as TransactionStatusEnum,
        Declined: 'DECLINED' as TransactionStatusEnum,
        Reported: 'REPORTED' as TransactionStatusEnum
    };
}


